export const environment = {
  production: true,
  apiUrl: 'https://demo-backend.mario.zp.ua/api'
};
